import { getFdrGeoStaticPageComponents } from 'components/domain/fdr-geo/fdr-geo.utils';
import { fdrGeoPageComponentsVars } from 'components/page/geo/geo.vars';
import { fdrThemeGeoPageComponentsVars } from 'components/page/theme-geo/theme-geo.vars';
import { FdrPageComponentsFragment } from 'schemas/fragment/page-components/fdr-page-components.generated';
import { useFdrGeoStaticPageComponentsQuery } from 'schemas/query/geo/fdr-geo-static-page-components.generated';
import { useFdrThemeGeoPageComponentQuery } from 'schemas/query/theme-geo/fdr-theme-geo-page-components.generated';

function useThemeGeoPageComponents(
  themeId: string,
  geoId: string
): FdrPageComponentsFragment['components'] {
  const { data } = useFdrThemeGeoPageComponentQuery({
    variables: {
      input: {
        themeId,
        geoId,
      },
      ...fdrThemeGeoPageComponentsVars,
    },
  });

  const { data: geoStaticPageComponentsData } =
    useFdrGeoStaticPageComponentsQuery({
      variables: {
        input: {
          publicId: geoId,
        },
        ...fdrGeoPageComponentsVars,
      },
    });

  const pageComponents =
    data?.fdrThemeGeoPage?.page?.pageComponents.components ?? [];
  const geoStaticPageComponents =
    getFdrGeoStaticPageComponents(geoStaticPageComponentsData?.fdrGeo)
      ?.components || [];

  return pageComponents.concat(geoStaticPageComponents);
}

export default useThemeGeoPageComponents;
